import React from "react";
import $ from "jquery";

import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import VideoNotes from "./VideoNotes";

import RelatedTeacher from "./RelatedTeacher";
import axios from "axios";
import CryptoJS from "crypto-js";

const Teacher = () => {
  const { id } = useParams();

  const [Teacher, setTeacher] = useState(null);
  const [Video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);

  const sectionRef = useRef(null);
  const location = useLocation();

  //fetch teacher details according id
  useEffect(() => {
    axios
      .get(`https://topfaculty.co.in/api/teacher-list2.php?TeacherId=${id}`)
      .then((response) => {
        console.log(response.data.TeacherName);
        setTeacher(response.data);
      })
      .catch((error) => {
        console.log("Error Fetching Data", error);
      });
  }, [id]);

  // ENCRYPTION VIDEO LINK
  const secretKey = "sachin";
  const encryptFilename = (filename) => {
    return CryptoJS.AES.encrypt(filename, secretKey).toString();
  };
  const decryptFilename = (cipherText) => {
    const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  };

  useEffect(() => {
    axios
      .get(`https://topfaculty.co.in/api/video_fetch.php?TeacherId=${id}`)
      // .get(`https://viasacademy.com/viasapi/vedioapi.php`)
      .then((response) => {
        console.log(response.data);
        setVideo(response.data);
        console.log("Video Data:", response.data.length);
   
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error Fetching Video Data", error);
        setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    // Wait until table data is rendered
    if (Video && Video.length > 0) {
      // Prevent multiple initializations
      if ($.fn.DataTable.isDataTable("#example")) {
        $("#example").DataTable().destroy(); // destroy previous instance
      }

      setTimeout(() => {
        $("#example").DataTable(); // initialize again
      }, 100); // small delay to ensure table is rendered
    }
  }, [Video]);

  //scroll top
  useEffect(() => {
    // Check if navigation state has scrollToSection and scroll
    if (location.state?.scrollToSection && sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [location]);

  return (
    <>
      {/* Courses Details Start */}

      <div className="rs-courses-details ">
        <img
          src="assetsfront/images/teacher.jpg"
          alt="student registration"
          style={{
            marginTop: "0%",
            width: "100%",
            // height: "200px",
            objectFit: "cover",
          }}
        />

        <div className="container">
          <div className="row mt-4">
            <h1 className="title text-center" style={{ fontWeight: "600" }}>
              Our <strong style={{ color: "#f7b205" }}> Teacher</strong>
            </h1>

            {Teacher ? (
              Teacher.map((item, index) => (
                <div className="col-lg-8 col-md-12">
                  <div className="course-content" ref={sectionRef}>
                    <div className="course-instructor">
                      <div className="row">
                        <div className="col-md-5 mobile-mb-20">
                          <h3 className="instructor-title">
                            COURSE{" "}
                            <span className="primary-color">INSTRUCTOR </span>
                          </h3>
                          <div className="instructor-inner">
                            <div className="instructor-img">
                              <img
                                src={
                                  item.TeacherProfile
                                    ? item.TeacherProfile
                                    : "https://i.pinimg.com/736x/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg"
                                }
                                alt="Teachers Images"
                              />
                            </div>
                            <div className="instructor-body">
                              <h3 className="name">{item.TeacherName} </h3>
                              <span className="designation">
                                {item.TeacherEmail}{" "}
                              </span>
                              <div className="social-icon">
                                {/* <a href={item.facebook}>
                                  <i
                                    style={{
                                      color: "blue",
                                      fontSize: "23px",
                                      fontWeight: "700",
                                    }}
                                    className="fa fa-facebook"
                                  />
                                </a>

                                <a href={item.youtube}>
                                  <i
                                    style={{
                                      background: "red",
                                      WebkitBackgroundClip: "text",
                                      WebkitTextFillColor: "transparent",
                                      fontSize: "26px",
                                      fontWeight: "100",
                                    }}
                                    className="fa fa-youtube"
                                  />
                                </a>
                                <a href={item.twitter}>
                                  <i
                                    style={{
                                      color: "rgb(30, 48, 80)",
                                      WebkitBackgroundClip: "text",
                                      fontSize: "26px",
                                      fontWeight: "100",
                                    }}
                                    className="fa fa-twitter"
                                  />
                                </a>
                                <a href={item.insta}>
                                  <i
                                    style={{
                                      background:
                                        "linear-gradient(45deg, #feda75, #fa7e1e, #d62976, #962fbf, #4f5bd5)",
                                      WebkitBackgroundClip: "text",
                                      WebkitTextFillColor: "transparent",
                                      fontSize: "27px",
                                      fontWeight: "900",
                                    }}
                                    className="fa fa-instagram"
                                  />
                                </a>

                                <a href={item.telegram}>
                                  <i
                                    style={{
                                      color: "#007bff",
                                      WebkitBackgroundClip: "text",
                                      fontSize: "26px",
                                      fontWeight: "100",
                                    }}
                                    className="fa fa-telegram"
                                  />
                                </a> */}
                                <a className="adds" href={item.facebook}>
                                  <img
                                    src="assetsfront/images/facebook.png"
                                    style={{ width: "32px", height: "34px" }}
                                  />
                                </a>
                                <a className="adds" href={item.youtube}>
                                  <img
                                    src="assetsfront/images/youtube.png"
                                    style={{ width: "32px", height: "34px" }}
                                  />
                                </a>
                                <a className="adds" href={item.twitter}>
                                  <img
                                    src="assetsfront/images/tweet.webp"
                                    style={{ width: "32px", height: "34px" }}
                                  />
                                </a>
                                <a className="adds" href={item.insta}>
                                  <img
                                    src="assetsfront/images/instagram.png"
                                    style={{ width: "32px", height: "34px" }}
                                  />
                                </a>
                                <a className="adds" href={item.telegram}>
                                  <img
                                    src="assetsfront/images/telegram.png"
                                    style={{ width: "32px", height: "34px" }}
                                  />
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="short-desc">
                            <p>
                              Top Faculty is a powerful platform for educators
                              to reach students across India and share their
                              expertise.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-7">
                          <h3 className="instructor-title">
                            BASIC{" "}
                            <span className="primary-color">INFORMATION</span>
                          </h3>
                          <div className="row info-list">
                            <div className="col-md-6">
                              <ul>
                                <li>
                                  <span>Experience :</span>{" "}
                                  {item.TeacherExperience}
                                </li>
                                <li>
                                  <span>Examination :</span>{" "}
                                  {item.TeacherExamination}
                                </li>
                                <li>
                                  <span>Course :</span> {item.TeacherCourse}
                                </li>
                                <li>
                                  <span>Subject :</span> {item.TeacherSubject}
                                </li>
                                <li>
                                  <span>Address :</span> {item.TeacherAddress}
                                </li>
                              </ul>
                            </div>
                            <div className="col-md-6">
                              <ul>
                                <li>
                                  <span>Mobile :</span> {item.TeacherMobile}
                                </li>
                                <li>
                                  <span>Medium :</span>
                                  {item.TeacherMedium}
                                </li>
                                <li>
                                  <span>Fee :</span>
                                  {item.TeacherCharge}
                                </li>
                                <li>
                                  <div className="social-icon ">
                                    <a className="adds" href="tel:9911753333">
                                      <img
                                        src="assetsfront/images/phon.png"
                                        style={{
                                          width: "32px",
                                          height: "34px",
                                        }}
                                      />
                                    </a>
                                    <a
                                      className="adds"
                                      href="mailto:topfauclty01@gmail.com"
                                    >
                                      <img
                                        src="assetsfront/images/email.jpg"
                                        style={{
                                          width: "32px",
                                          height: "34px",
                                        }}
                                      />
                                    </a>

                                    <a
                                      className="adds"
                                      href="https://www.facebook.com/topfacultyho/?show_switched_toast=0&show_invite_to_follow=0&show_switched_tooltip=0&show_podcast_settings=0&show_community_review_changes=0&show_community_rollback=0&show_follower_visibility_disclosure=0"
                                    >
                                      <img
                                        src="assetsfront/images/facebook.png"
                                        style={{
                                          width: "32px",
                                          height: "34px",
                                        }}
                                      />
                                    </a>
                                    <a
                                      className="adds"
                                      href="https://www.youtube.com/@vedantaiasacademy7008"
                                    >
                                      <img
                                        src="assetsfront/images/youtube.png"
                                        style={{
                                          width: "32px",
                                          height: "34px",
                                        }}
                                      />
                                    </a>
                                    <a
                                      className="adds"
                                      href="https://x.com/i/flow/login?redirect_after_login=%2FVEDANTA_IAS"
                                    >
                                      <img
                                        src="assetsfront/images/tweet.webp"
                                        style={{
                                          width: "32px",
                                          height: "34px",
                                        }}
                                      />
                                    </a>
                                    <a
                                      className="adds"
                                      href="https://www.instagram.com/vedantaias97/#"
                                    >
                                      <img
                                        src="assetsfront/images/instagram.png"
                                        style={{
                                          width: "32px",
                                          height: "34px",
                                        }}
                                      />
                                    </a>
                                    <a
                                      className="adds"
                                      href="https://www.linkedin.com/in/vedanta-ias-academy-75b042146/"
                                    >
                                      <img
                                        src="assetsfront/images/linkedin.png"
                                        style={{
                                          width: "32px",
                                          height: "34px",
                                        }}
                                      />
                                    </a>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="apply-btn">
                             <a
                              href={`https://cxqyp.courses.store/770868?utm_source%3Dother%26utm_medium%3Dtutor-course-referral%26utm_campaign%3Dcourse-overview-webapp`}
                              style={{ background: "rgb(9 11 89)" }}
                            >
                              Live Class
                            </a>
                            {/* <a
                              href={`https://sfu.mirotalk.com/join/${item.TeacherName}-${item.TeacherId}`}
                              style={{ background: "rgb(9 11 89)" }}
                            >
                              Live Class
                            </a> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <span
                style={{
                  fontWeight: "bold",
                  color: "#002347",
                  fontSize: "30px",
                }}
              >
                Please wait
                <span className="dot-loader">
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                </span>
              </span>
            )}

            <div className="col-lg-4 col-md-12 ">
              <div
                className="rs-about "
                style={{ boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px" }}
              >
                {/* <div className="text-center">
                  <div className="about-img rs-animation-hover">
                    <img
                      src="../../assetsfront/images/hthub2.png"
                      style={{ opacity: "0.8", height: "270px" }}
                      alt="img02"
                    />
                    <a
                      className="popup-youtube rs-animation-fade"
                      href="https://media.viasacademy.com/Top%20faculty/top%20faculty.mp4"
                      title="Video Icon"
                    ></a>
                    <div className="overly-border" />
                  </div>
                </div> */}

                <div className="table-responsive">
                  <h3 className="text-center mt-4">Free-Videos</h3>{" "}
                  <table
                    className="table table-striped table-bordered"
                    style={{
                      width: "100%",
                      boxShadow:
                        "inset rgba(0, 0, 0, 0.35) 1px -rgb(166 166 166 / 35%) 4px -1px 3px -5px inset 14px 0px",
                    }}
                  >
                    <thead
                      style={{
                        color: "#ffffff",
                        background: "green",
                      }}
                    >
                      <tr>
                        <th>Sr No.</th>
                        <th>Topic</th>
                        <th>View Video </th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* Video link block */}
                      {Teacher &&
                        Teacher.map((item, index) => {
                          const videoLinks = Array.isArray(item.videoLink)
                            ? item.videoLink
                            : JSON.parse(item.videoLink || "[]");
                          const firstThreeLinks = videoLinks.slice(0, 4); // Limit to first 6

                          return (
                            <React.Fragment key={index}>
                              {firstThreeLinks.length > 0 ? (
                                firstThreeLinks.map((onvideo, idx) => (
                                  <tr key={idx}>
                                    <td style={{ textAlign: "center" }}>
                                      {idx + 1}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      Demo {idx + 1}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <a
                                        href={`${onvideo}`}
                                        style={{ color: "black" }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <i
                                          className="fa fa-youtube-play"
                                          style={{
                                            fontSize: "25px",
                                            color: "red",
                                          }}
                                          aria-hidden="true"
                                        ></i>
                                      </a>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr key="no-video">
                                  <td
                                    colSpan={4}
                                    style={{
                                      textAlign: "center",
                                      color: "gray",
                                    }}
                                  >
                                    Not Available
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Courses Details End */}

      <div
        id="rs-latest-news-style7"
        className="rs-latest-news-style7 sec-spacer"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="rs-latest-list">
                <div className="latest-wrap">
                  <div className="shipping-area">
                    <div className="container">
                      <div className="tab-content">
                        <div className="tab-pane active" id="checkout">
                          <Link to={`/all-Videos`}>
                            <button class="blink-button">🎥 All Videos  </button>
                          </Link>{" "}
                          &nbsp;
                          <Link to={`/all-notes`}>
                            <button class="blink-button2">
                              📝 All Notes or Books
                            </button>
                          </Link>
                          <div className="row">
    
                            <h2 className="title pb-20 md-pb-30 uppercase">
                              Videos And Notes &nbsp;
                              {Teacher?.map((item, index) => (
                                <span class="info-color" key={index}>
                                  {item.TeacherName}
                                </span>
                              ))}
                            </h2>




                            

                            <div className="table-responsive">
                                       <h6>{Video && Video.length > 0 ? `Total Videos: ${Video.length}` : "No videos available"}</h6>

                              <table
                                id="example"
                                className="table table-striped table-bordered"
                                style={{
                                  width: "100%",
                                  boxShadow:
                                    "inset rgba(0, 0, 0, 0.35) 1px -rgb(166 166 166 / 35%) 4px -1px 3px -5px inset 14px 0px",
                                }}
                              >
                                <thead
                                  style={{
                                    color: "black",
                                    background: "#f7b205",
                                  }}
                                >
                                  <tr>
                                    <th>Sr No.</th>
                                    <th>Topic</th>
                                    <th>Uploaded Date</th>
                                    <th>View Video </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  
                                  
                                  {loading ? (
                                    <tr>
                                      <td
                                        colSpan={7}
                                        style={{ textAlign: "center" }}
                                      >
                                        <span
                                          style={{
                                            fontWeight: "bold",
                                            color: "#002347",
                                            fontSize: "30px",
                                          }}
                                        >
                                          Please wait
                                          <span className="dot-loader">
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                          </span>
                                        </span>
                                      </td>
                                    </tr>
                                  ) : Video && Video.length > 0 ? (
                                    
                                    Video.map((video, index) => (
                                       
                                      <tr key={index}>
                                        <td>
                                          <p
                                            style={{
                                              color: "black",
                                              fontWeight: "700",
                                            }}
                                          >
                                            {index + 1}
                                          </p>
                                        </td>
                                        <td style={{ width: "30%" }}>
                                          {(() => {
                                            const encrypted = encryptFilename(
                                              video.vid_video
                                            );
                                            return (
                                              <Link
                                                to={`/runningvideo/${encodeURIComponent(
                                                  encrypted
                                                )}/${encodeURIComponent(
                                                  video.vid_topic
                                                )}/${video.vid_id}`}
                                              >
                                                <h6
                                                  style={{
                                                    color: "blue",
                                                    fontWeight: "700",
                                                    fontSize: "18px",
                                                  }}
                                                >
                                                  {video.vid_topic}
 
                                                </h6>
                                              </Link>
                                            );
                                          })()}
                                        </td>
                                        <td>
                                          <p>{video.vid_date}</p>
                                        </td>
                                        <td>
                                          <strong>
                                            {(() => {
                                              const encrypted = encryptFilename(
                                                video.vid_video
                                              );
                                              return (
                                                <Link
                                                  to={`/runningvideo/${encodeURIComponent(
                                                    encrypted
                                                  )}/${encodeURIComponent(video.vid_topic
                                                  )}/${video.vid_id}`}
                                                >
                                                  <i
                                                    className="fa fa-youtube-play"
                                                    style={{
                                                      fontSize: "25px",
                                                      color: "red",
                                                    }}
                                                    aria-hidden="true"
                                                  ></i>
                                                </Link>
                                              );
                                            })()}
                                          </strong>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan={7}>
                                        <p style={{ textAlign: "center" }}>
                                          No video available
                                        </p>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <VideoNotes /> */}
      <RelatedTeacher />
    </>
  );
};

export default Teacher;
